import { createStyles, Theme } from '@mui/material'

const styles = ({ palette, spacing }: Theme) =>
  createStyles({
    buttonIcon: {
      fill: palette.secondary.contrastText,
      marginLeft: -spacing(0.5),
      marginRight: spacing(0.5),
    },
    fabButton: {
      position: 'fixed',
      zIndex: 10,
      right: spacing(2),
      bottom: spacing(2),
    },
  })

export default styles
